import { setContext, setUser, User } from "@sentry/react";

export const setUserInfo = (user: User) => {
  setUser({
    id: user.id,
    email: user.email,
  });
};

export const setProfileContext = (
  key: string,
  context: Record<string, unknown>,
) => {
  setContext(key, context);
};
